<!-- <div class="fixed-top">
  <div class="d-flex flex-column">
    <app-header #header></app-header>
    <app-breadcrumb></app-breadcrumb>
  </div>
</div>
<div id="backset" style="height:45px;"></div>
<nav aria-label="breadcrumb">
  <ol class="breadcrumb mb-0">
    <li class="breadcrumb-item active" aria-current="page">Employee Career Path</li>
  </ol>
</nav> -->

<div class="fixed">
  <div class="page-content">

    <div class="d-flex">
      <mat-drawer-container class="career-path-sidenav-container" autosize>
        <mat-drawer #drawer class="career-path-sidenav" mode="side" opened="true"
          (openedChange)="onOpenedChange($event)">
          <mat-tab-group class="tab-group">
            <!-- <div class="toggle-button">
              <button *ngIf="!isSideBarOpened" class="border-0 toggle" (click)="drawer.toggle()"><i
                  class="fa fa-angle-right"></i></button>
              <button *ngIf="isSideBarOpened" class="border-0 toggle" (click)="drawer.toggle()"><i
                  class="fa fa-angle-left"></i></button>
            </div> -->

            <mat-tab label="ALL CAREERS">
              <div class="mb-2 search_section">
                <input type="search" class="elastic-search carrer-search"
                  placeholder="Search by Competency or Sub Competency" (input)="search($event.target.value)"
                  [(ngModel)]="txt">
                <button type="submit" class="elastic-search-icon" *ngIf="txt==''"><i
                    class="fa fa-search elastic-icon"></i></button>
                <button type="submit" (click)="search('')" class="elastic-search-icon" *ngIf="txt"><i
                    class="fa fa-times elastic-icon"></i></button>
              </div>
              <div class="pl-3 pr-3 pb-3 pt-0">
                <mat-accordion>
                  <mat-expansion-panel *ngFor="let practice of filteredPractices;let i=index"
                    [expanded]="practice?.practiceName == employeeDetails?.practice ? true : i===0"
                    class="mb-2 main-header" hideToggle>
                    <mat-expansion-panel-header class="practiceTitleContainer">
                      <mat-panel-title class="practiceTitle">
                        <!-- <div>
                          <img src="../../../../assets/images/employeeCareer/option.png" class="pl-2">
                        </div> -->
                        <div class="d-flex align-items-start justify-content-between w-100 pl-2">
                          <div class="fw-700 text-left">{{practice?.practiceName}}</div>
                          <div>
                            <mat-icon class="icon_arrow">keyboard_arrow_down</mat-icon>
                            <!-- <mat-icon class="icon_circle"
                            *ngIf="practice.practiceName != employeeDetails.practice ? true : i===0">keyboard_arrow_up</mat-icon> -->
                          </div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="departments-container">
                      <ul id="myList" class="nav-sub-childmenu">
                        <li class="department-item pl-3 mt-2"
                          *ngFor="let department of practice?.departments; let i = index" [value]="department"
                          [class.selected]="isSelected(department)" (click)="getCareerPath(practice, department)">
                          {{department.departmentName}}</li>
                      </ul>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            </mat-tab>
          </mat-tab-group>

        </mat-drawer>

        <mat-drawer-content class="drawer-content">
          <div class="career-path-sidenav-content">
            <div class="mainContent">
              <div class="d-flex justify-content-between heading_section">
                <div class="toggle-button">
                  <button *ngIf="!isSideBarOpened" class="toggle" (click)="drawer.toggle()"><i
                      class="fa fa-angle-right"></i></button>
                  <button *ngIf="isSideBarOpened" class="toggle" (click)="drawer.toggle()"><i
                      class="fa fa-angle-left"></i></button>
                </div>
                <div class="text-left">
                  <span *ngIf="selectedPracticeName?.length>0" class="PnameDname">{{selectedPracticeName}} |
                    {{selectedDepartmentName}}<br></span>
                  <p class="mb-0 view_career_text">View career paths and request for a change</p>
                </div>
                <div>
                  <a style="text-decoration: underline; color: var(--blue6);" [href]="approvedCertifications"
                    target="_blank">Approved
                    Certifications</a>
                </div>

              </div>
              <div *ngIf="practicePaths?.length>0" class="shadow-none">
                <div>
                  <div class="graph">
                    <app-career-path [data]="getGraphData()" [practiceId]="practicePaths[0]?.id"
                      [departmentId]="practicePaths[0]?.departmentPaths[0]?.id"
                      [departmentName]="practicePaths[0]?.departmentPaths[0]?.name"
                      [practiceName]="practicePaths[0]?.name"></app-career-path>
                  </div>
                </div>
              </div>
              <div *ngIf="loading" class="m-0 p-0  mt-2 shadow-none center-content" style="z-index: 100;">
                <mat-progress-spinner mode="indeterminate" diameter="60" strokeWidth="3"></mat-progress-spinner>
              </div>
              <div *ngIf="!(practicePaths?.length>0) && !isCareerPathLoading">
                <!-- <div>No Data</div> -->
                <div class="noDataCard align-items-center mt-0">
                    <div class="noDataCardIn">
                      <img src="../../../assets/images/no_data.png" height="350px"><br>
                      <span class="mt-3 d-block"> No Career Path found</span>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </mat-drawer-content>

      </mat-drawer-container>
    </div>
  </div>

</div>